<ng-container *ngIf="error$ | async as errorMsg; else resultTemplate">
  <em-error-result [subTitle]="errorMsg"></em-error-result>
</ng-container>

<ng-template #resultTemplate>
  <nz-skeleton
    [nzParagraph]="{ rows: 11 }"
    [nzActive]="true"
    [nzLoading]="(loading$ | async) ?? false"
  >
    <ng-container *ngIf="pagination$ | async as histories; else noData">
      <ng-container *ngFor="let history of histories.data; trackBy: trackByRef">
        <nz-descriptions nzLayout="vertical" [nzTitle]="itemTitleTemplate">
          <nz-descriptions-item nzTitle="Not. type">
            <em-display-property [value]="history.notificationTypeText"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Created by">
            <em-display-property [value]="history.createdBy"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Creation date">
            <em-display-property
              [value]="(history.createdDate | date: 'shortDate') ?? ''"
            ></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Workorder no.">
            <em-display-property [value]="history.orderNumber"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Work center">
            <em-display-property [value]="history.workCenterText"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Termin">
            <em-display-property
              [value]="(history.notificationDate | date: 'shortDate') ?? ''"
            ></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Priority">
            <em-display-property [value]="history.priorityText"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Location">
            <em-display-property [value]="history.locationText"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Row/place">
            <em-display-property [value]="history.room"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Assembly">
            <em-display-property [value]="history.assembly"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Coding">
            <em-display-property [value]="history.codingText"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Assigned person">
            <em-display-property [value]="history.reportingPerson"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Start date">
            <em-display-property
              [value]="(history.startMalfunctionDate | date: 'shortDate') ?? ''"
            ></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="End date">
            <em-display-property
              [value]="(history.endMalfunctionDate | date: 'shortDate') ?? ''"
            ></em-display-property>
          </nz-descriptions-item>
        </nz-descriptions>
        <ng-template #itemTitleTemplate>
          <nz-divider [nzText]="dividerText" nzOrientation="left">
            <ng-template #dividerText>Notification: {{ history.notificationNumber }}</ng-template>
          </nz-divider>
        </ng-template>
      </ng-container>

      <nz-pagination
        nzShowSizeChanger
        [nzPageSizeOptions]="[1, 2, 5]"
        [(nzPageSize)]="perPage"
        [(nzPageIndex)]="page"
        (nzPageSizeChange)="pageSizeChange($event)"
        (nzPageIndexChange)="paginationRef.setPage($event)"
        [nzTotal]="histories.total"
      ></nz-pagination>
    </ng-container>
  </nz-skeleton>
</ng-template>

<ng-template #noData>
  <nz-empty></nz-empty>
</ng-template>
